import React from "react";
import "./style.scss";
import PropTypes from "prop-types";
export default function BaseSingleCheckbox({
  checkboxStyle,
  checkedValue,
  onCheckValue,
  className,
  children,
}) {
  BaseSingleCheckbox.propTypes = {
    checkedValue: PropTypes.bool,
    onCheckValue: PropTypes.func,
    className: PropTypes.string,
    checkboxStyle: PropTypes.string,
    children: PropTypes.node,
  };
  const cls = ["single-checkbox"];
  const checkboxStyles = ["single-checkbox__checkbox"];
  if (className) cls.push(className);
  if (checkboxStyle) cls.push(checkboxStyle);
  if (checkedValue) checkboxStyles.push("single-checkbox__checkbox_checked");
  return (
    <div className={cls.join(" ")}>
      <div onClick={onCheckValue} className={checkboxStyles.join(" ")} />
      {children}
    </div>
  );
}
